import { createDomain, sample } from 'effector';

import { ChangedDocuments } from 'types/zod/changed-documents';
import { QuestionnaireInstance } from 'types/zod/questionnaire-instance';

const domain = createDomain('pages/summary');

const updateAllButtonClicked = domain.createEvent();
const updateChangedButtonClicked = domain.createEvent();
const revertButtonClicked = domain.createEvent();
const generateButtonClicked = domain.createEvent();

const updateAllFx = domain.effect<number, Promise<void>>();
const updateChangedFx = domain.effect<
    { questionnaireInstanceId: number; changedDocuments: ChangedDocuments },
    Promise<void>
>();
const revertFx = domain.effect<number, Promise<void>>();

const $qInstanceId = domain.createStore<QuestionnaireInstance['questionnaire_instance_id'] | null>(null);
const $answers = domain.createStore<any | null>(null);
const $isGenerationRequestPending = domain.createStore<boolean>(false);

const $$summaryPage = {
    domain,
    stores: {
        $qInstanceId,
        $answers,
        $isGenerationRequestPending,
        buttonsPending: {
            $updateAll: updateAllFx.pending,
            $updateChanged: updateChangedFx.pending,
            $revert: revertFx.pending,
            $any: sample({
                source: [updateAllFx.pending, updateChangedFx.pending, revertFx.pending],
                fn: (statuses) => statuses.some((status) => status),
            }),
        },
        $changedDocs: domain.createStore<ChangedDocuments>({ toBeUpdated: [], toBeRemoved: [] }),
    },
    $confirmationModalEnabled: domain.createStore<boolean>(false),

    events: {
        generateButtonClicked,
        updateAllButtonClicked,
        updateChangedButtonClicked,
        revertButtonClicked,
    },
    effects: {
        updateAllFx,
        updateChangedFx,
        revertFx,
    },
};

export default $$summaryPage;
